import { Redux } from '../..'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { GygEonActions, GygEonActionsPayload, GygEonActionsQueryOptions } from '@/src/types/apps/gygEonActions'

interface EonActionsInitialState {
  actions: GygEonActions | null
  loading: boolean
  success: string | null
  error: string | null
}

const initialState: EonActionsInitialState = {
  actions: null,
  loading: false,
  success: null,
  error: null
}

interface EonActionsResponse {
  data: GygEonActions
}

export const getEonActionsInTwoDates = createAsyncThunk<EonActionsResponse, GygEonActionsQueryOptions, Redux>(
  'gygEonActions/getEonActionsInTwoDates',
  async (gygEonActionsQueryOptions, { extra }) => {
    const { restaurantId, startDate, endDate } = gygEonActionsQueryOptions

    const { data: responseData } = await extra.httpClient.get(`restaurants/${restaurantId}/eon-actions/latest`, {
      params: {
        startDate,
        endDate
      }
    })

    return responseData
  }
)

export const saveEonActions = createAsyncThunk<void, GygEonActionsPayload, Redux>(
  'gygEonActions/saveEonActions',
  async (gygEonGoalsTarget, { extra }) => {
    const { restaurantId, ...payload } = gygEonGoalsTarget

    await extra.httpClient.post(`restaurants/${restaurantId}/eon-actions`, payload)
  }
)

const gygEonActionsSlice = createSlice({
  name: 'getAllEonActions',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getEonActionsInTwoDates.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getEonActionsInTwoDates.fulfilled, (state, action) => {
        state.loading = false
        state.success = null
        state.actions = action.payload.data
      })
      .addCase(getEonActionsInTwoDates.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message ?? 'Failed to fetch eon goals targets'
      })
      .addCase(saveEonActions.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(saveEonActions.fulfilled, state => {
        state.loading = false
        state.success = 'Eon goals targets saved successfully'
        state.error = null
      })
      .addCase(saveEonActions.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message ?? 'Failed to save eon goals targets'
      })
  }
})

export default gygEonActionsSlice.reducer
